import List from "components/list";
import { IntegrationProjectCell, PROJECT_FIELDS, projectNameSearch } from "../cells";

// All Discord channels across projects, from projects__integrations.
// Only the channel id is stored (no server id), so it can't be turned into a link.
export default function DiscordIntegrations({ storageKey = "integrations-discord", title = "Discord" }) {
  const columns = [
    {
      id: "project",
      header: "Project",
      accessorKey: "projects",
      cell: IntegrationProjectCell,
    },
    {
      id: "channel",
      header: "Channel ID",
      accessorKey: "item.channel_id",
      cell: ({ row }) => row.original?.item?.channel_id || "—",
    },
  ];

  const fields = [
    "id",
    ...PROJECT_FIELDS,
    "item:integrations_discord.id",
    "item:integrations_discord.channel_id",
  ];

  return (
    <div className="w-full">
      <div className="flex-1 h-full">
        <List
          title={title}
          endPoint="projects__integrations"
          sortBy="id"
          storageKey={storageKey}
          filters={{ collection: { _eq: "integrations_discord" } }}
          columns={columns}
          meta={{ fields, customSearch: projectNameSearch }}
          searchPlaceholder="Search project"
          href={(row) => row?.item?.id && `/integrations/discord/${row.projects?.project_id}/${row.item.id}`}
        />
      </div>
    </div>
  );
}
